import AppNew from "./components/AppNew";
import { createRoot } from "react-dom/client";
import { AppNotifications } from "./components/AppNotifications";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ConfigAppLocks } from "./components/locking/ConfigAppLocks";
import {
  LockedBatchProvider,
  LockedModelProvider,
} from "./components/locking/contexts/GoodLockProvider";
import { UserDetailsProvider } from "./components/login/UserDetailsProvider";

const rootEl = document.getElementById("root")!;
const root = createRoot(rootEl);

const API_HOST = import.meta.env.VITE_API_HOST;
const ACCELERATOR_VERSION = import.meta.env.VITE_ACCELERATOR_VERSION;
console.log(
  "index.tsx",
  {
    API_HOST,
    ACCELERATOR_VERSION,
  },
  import.meta.env,
);
root.render(
  <LockedModelProvider>
    <LockedBatchProvider>
      <UserDetailsProvider>
        <ErrorBoundary>
          <AppNotifications>
            {(
              deleteFailedAlert,
              deleteSuccessAlert,
              reprocessFailedAlert,
              reprocessSuccessAlert,
              modelPagesFailedAlert,
              modelSaveSuccessAlert,
              modelSaveFailureAlert,
            ) => (
              <ConfigAppLocks>
                {(isLocked, lock, unlock, lockedBy, unlockAll) => (
                  <AppNew
                    isLocked={isLocked}
                    lock={lock}
                    unlock={unlock}
                    lockedBy={lockedBy}
                    unlockAll={unlockAll}
                    deleteFailedAlert={deleteFailedAlert}
                    deleteSuccessAlert={deleteSuccessAlert}
                    reprocessFailedAlert={reprocessFailedAlert}
                    reprocessSuccessAlert={reprocessSuccessAlert}
                    modelPagesFailedAlert={modelPagesFailedAlert}
                    modelSaveSuccessAlert={modelSaveSuccessAlert}
                    modelSaveFailureAlert={modelSaveFailureAlert}
                    hostname={API_HOST}
                    version={ACCELERATOR_VERSION}
                  />
                )}
              </ConfigAppLocks>
            )}
          </AppNotifications>
        </ErrorBoundary>
      </UserDetailsProvider>
    </LockedBatchProvider>
  </LockedModelProvider>,
);
